import { Alert } from '@designsforhealth/dfh-react-components'
import React from 'react'

import { GetCustomerInvoiceDocument } from '../../../../../graphql/camel'
import useCamelQuery from '../../../../../hooks/useCamelQuery'
import useLogAndCaptureError from '../../../../../hooks/useLogAndCaptureError'
import { useOtherCustomerIds } from '../../../../../hooks/useOtherCustomerIds'
import ContactSupportMessage from '../../../../ContactSupportMessage'
import Spinner from '../../../../Spinner'
import QueryFallback from '../../QueryFallback'
import InvoiceContainer from './InvoiceContainer'

export interface CustomerInvoiceContainerProps {
  invoiceId: string
}

const CustomerInvoiceContainer: React.FC<CustomerInvoiceContainerProps> = ({ invoiceId }) => {
  const { data, error, loading, refetch } = useCamelQuery(GetCustomerInvoiceDocument, {
    variables: { invoiceId, otherCustomerIds: useOtherCustomerIds() },
  })
  useLogAndCaptureError(error)

  const invoice = data?.getCustomerInvoice

  if (loading) {
    return <Spinner loading />
  }

  return (
    <>
      {!!error && (
        <QueryFallback buttonText="Retry Loading Invoice" error={error} onRetry={() => refetch()} />
      )}
      {!error && !invoice && (
        <Alert type="attention">
          Requested invoice details not found. <ContactSupportMessage />
        </Alert>
      )}
      {!!invoice && <InvoiceContainer invoice={invoice} />}
    </>
  )
}

export default CustomerInvoiceContainer
